import React from 'react';

const CloseAccount = () => {
    return (
        <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}>
            <h1 style={{ fontSize: "24px", fontWeight: "bold", color: "#333" }}>Close Your Account</h1>
            <p style={{ fontSize: "16px", color: "#4F4F4F", marginBottom: "20px" }}>
                If you wish to close your Gatnix account, please follow the steps below to ensure a smooth process.
            </p>
            <ol style={{ fontSize: "16px", color: "#4F4F4F", marginLeft: "20px" }}>
                <li>
                    <strong>Log in to Your Account:</strong> Access your Gatnix account with your credentials.
                </li>
                <li>
                    <strong>Go to Account Settings:</strong> Navigate to the "Account Settings" section from your dashboard or profile menu.
                </li>
                <li>
                    <strong>Select "Close Account":</strong> Look for the "Close Account" option and click on it.
                </li>
                <li>
                    <strong>Confirm Your Decision:</strong> You may need to verify your identity by entering your password or confirming via email.
                </li>
                <li>
                    <strong>Review Final Information:</strong> Ensure you download any important data linked to your account before closing it.
                </li>
                <li>
                    <strong>Submit the Request:</strong> Click the "Submit" or "Confirm" button to finalize the process.
                </li>
            </ol>
            <p style={{ fontSize: "16px", color: "#4F4F4F", marginTop: "20px" }}>
                <strong>Note:</strong> Once your account is closed, it cannot be reopened, and all associated data will be permanently deleted.
            </p>
            <p style={{ fontSize: "16px", color: "#4F4F4F" }}>
                If you encounter any issues or have questions, please contact our 24/7 support team via live chat on the Gatnix website or call us at{" "}
                <strong style={{ color: "#000000" }}>+1 (614) 421-7545</strong>.
            </p>
        </div>
    );
};

export default CloseAccount;
